import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import React from 'react';
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from '../../../../components/table/TableOps';
import ManifiestoInfo from './ManifiestoInfo';
import ACCESS from '../../../../ACCESS';

class ManifiestosCliente extends TableComponent {
	componentDidMount() {
		// const { params } = this.props.match;
		// const { idCliente = null, selectOne = false } = this.props;
		// // console.log(this.props)
		// let actions = [];
		// if (selectOne)
		// 	actions.push({ id: 'select', icon: 'check', cb: this.onSelect });

		// actions.push({ id: 'ver', icon: 'edit', cb: this.onVer })

		// this.tableConfig(
		// 	{ dataUrl: `cliente-manifiestos/${idCliente || this.props.match.params.id}/filter?sg=${selectOne ? 'true' : 'false'}`, deleteUrl: '', deleteField: '', modUrl: ``, query: { id_cliente: params.id } },
		// 	TableOp.Table('Manifiestos', [
		// 		{ label: 'Orden', id: 'orden' },
		// 		{ label: 'Factura', id: 'factura' },
		// 		{ label: 'Guía', id: 'id_guia' },
		// 	], actions)
		// );
		// this.table();
		this.loadTable();
	}

	loadTable() {
		const { params } = this.props.match;
		const { idCliente = null, selectOne = false } = this.props;
		let actions = [];
		if (selectOne) {
			actions.push({ id: 'select', icon: 'check', cb: this.onSelect, access: [ACCESS.GUIA.AGREGAR_MANIFIESTOS] });
		}

		actions.push({ id: 'ver', icon: 'edit', cb: this.onVer, access: [ACCESS.GUIA.AGREGAR_MANIFIESTOS] })

		this.tableConfig(
			{ dataUrl: `cliente-manifiesto/${idCliente || this.props.match.params.id}/filter?sg=${selectOne ? 'true' : 'false'}`, deleteUrl: '', deleteField: '', modUrl: ``, query: { id_cliente: params.id } },
			TableOp.Table('Manifiestos', [
				{ label: 'Orden', id: 'orden' },
				{ label: 'Factura', id: 'factura' },
				{ label: 'Guía', id: 'id_guia' },
				{ label: 'Fecha de carga', id: 'createdAt' },
			], actions)
		);
		this.table();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.idCliente !== this.props.idCliente) {
		this.loadTable();
		}
	}

	onSelect = (id, row) => {
		console.log(row);
		let { selected = [] } = this.state;
		// if (selectOne && onSelectOne)
		// 	onSelectOne(row);
		const rowSlected = selected.findIndex(se => se.id === row.id);
		if (rowSlected >= 0) {
			// ya existe en array, quitar
			selected = selected.filter((s, si) => si !== rowSlected);
		}
		else {
			// no existe, pushar
			selected.push(row)
		}
		this.setState({ selected });
	}

	onSelection = () => {
		const { selected } = this.state;
		let { selectOne, onSelectOne } = this.props;
		if (selected && selected.length > 0)
			if (selectOne && onSelectOne)
				onSelectOne(selected);
	}

	onVer = (id, row) => {
		this.setState({ dialogMan: { visible: true, idManifiesto: row.id } });
	}

	render() {
		const { dialogMan = { visible: false }, selected = [] } = this.state;
		const { selectOne = false } = this.props;

		return (
			<div>
				<div>
					{/* <Remitente onSave={() => { this.table() }}></Remitente> */}
					{
						selectOne && (
							<div>
								<p style={{ margin: 1, fontWeight: 'bold' }}>Seleccionado</p>
								{selected.map((se) => (
									<p style={{ margin: 1 }} key={se.id}>— {se.orden}</p>
								))}
								{selected.length > 0 && (
									<Button variant={"contained"} onClick={this.onSelection}>Seleccionar</Button>
								)}
							</div>
						)
					}


					<this.TableRender />



					<Dialog onClose={() => this.setState({ dialogMan: { visible: false } })} open={dialogMan.visible}>
						<DialogContent>
							<ManifiestoInfo manifiestoId={dialogMan.idManifiesto} />
						</DialogContent>
						<DialogActions>
							<Button autoFocus onClick={() => this.setState({ dialogMan: { visible: false } })} color="primary" variant={"contained"}>
								Cerrar
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</div>
		)
	}
}

const withRouterAndRef = (WrappedComponent) => {
	class InnerComponentWithRef extends React.Component {
		render() {
			const { forwardRef, ...rest } = this.props;
			return <WrappedComponent {...rest} ref={forwardRef} />;
		}
	}

	const ComponentWithRouter = withRouter(InnerComponentWithRef, { withRef: true });
	return React.forwardRef((props, ref) => {
		return <ComponentWithRouter {...props} forwardRef={ref} />;
	});
}

export default withRouterAndRef(ManifiestosCliente);
